import httpApiApplication from 'app/http/httpApiApplication';
import {
  type TaxReport,
  type TaxReportDetail,
  type TaxReportGeneralInfo
} from 'app/modules/Reports/types';

export const baseUrlReports = '/reports';

export const TaxReportList = (page: number, pageSize: number, params: any = undefined) => {
  // params.relations = ['Taxpayer'];
  return httpApiApplication.paginate<TaxReportGeneralInfo>(
    baseUrlReports + '/tax-reports',
    page,
    pageSize,
    params
  );
};

export const TaxReportDetailsList = (
  id: string,
  page: number,
  pageSize: number,
  params: any = undefined
) => {
  // params.relations = ['Taxpayer'];
  return httpApiApplication.paginate<TaxReportDetail>(
    baseUrlReports + '/tax-report/' + id + '/details',
    page,
    pageSize,
    params,
    true
  );
};

export const attachmentReport = (values: any, name: string): Promise<any> => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  return httpApiApplication.postCfg(
    'taxpayers/report/attachment' + '?' + 'name=' + name,
    values,
    config
  );
};

export const createTaxReport = (request: any): Promise<any> => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  return httpApiApplication.postCfg('taxpayers/report', request, config);
};

export const GetCurrentTaxReportFromTaxpayer = (request: TaxReport) => {
  const queryString = request.taxPeriodicityItemCode
    ? `?periodicityItem=${request.taxPeriodicityItemCode}`
    : '';
  return httpApiApplication.get<any>(
    `taxpayers/report/${request.code}/${request.year}${queryString}`
  );
};

export const getFormReportDefinition = (
  reportId: string,
  year: number,
  periodicityItem: string
) => {
  const queryString = periodicityItem ? `?periodicityItem=${periodicityItem}` : '';
  return httpApiApplication.get<any>(
    `/taxpayers/report/${reportId}/${year}/definition${queryString}`
  );
};
